import React from 'react';
import { TESTIMONIALS_HEADING, QSF_TESTIMONIALS } from '../../mock';
import { Quote, Star } from 'lucide-react';

export default function Testimonials() {
  return (
    <section id="stories" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-[11px] tracking-[0.25em] uppercase text-amber-300/80 mb-5">
          Real Clients · Real Shifts
        </p>
        <h2 className="font-serif text-white text-[32px] md:text-[52px] leading-[1.08] tracking-tight">
          {TESTIMONIALS_HEADING.pre}
          <br />
          <span className="italic text-amber-200">{TESTIMONIALS_HEADING.main}</span>
        </h2>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-14 columns-1 md:columns-2 lg:columns-3 gap-5">
        {QSF_TESTIMONIALS.map((t, i) => (
          <article
            key={i}
            className="mb-5 break-inside-avoid relative overflow-hidden rounded-2xl border border-white/10 bg-navy-900/50 p-7 transition-all duration-300 hover:border-amber-300/30 hover:-translate-y-[2px]"
          >
            <Quote
              className="absolute top-5 right-5 text-amber-300/15"
              size={38}
              strokeWidth={1.2}
            />
            <div className="flex items-center gap-0.5 text-amber-300">
              {[0, 1, 2, 3, 4].map((s) => (
                <Star key={s} size={13} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <p className="mt-4 text-neutral-200 text-[14px] leading-relaxed">
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="mt-5 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-300/40 to-amber-500/10 border border-amber-300/30 flex items-center justify-center text-amber-200 font-serif text-sm">
                {initials(t.name)}
              </div>
              <div>
                <p className="text-white font-serif text-[17px] leading-tight">{t.name}</p>
                {t.role && <p className="text-neutral-500 text-xs mt-0.5">{t.role}</p>}
              </div>
            </div>
          </article>
        ))}
      </div>

      <p className="max-w-3xl mx-auto px-6 mt-12 text-center text-neutral-500 text-[12px] md:text-[13px] leading-relaxed">
        All testimonials on this page are from real clients of Quantum Shift Formula. These
        individuals shared their experiences voluntarily, and their results are not typical. Your
        results may vary based on factors like your background, effort, mindset work, and
        implementation of the strategies.
      </p>
    </section>
  );
}

function initials(name) {
  return name
    .replace(/^Dr\.\s*/i, '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');
}
